function g(f, a) {
  var u = 0, n, t;
  a = a || {};
  function v() {
    var e = n, i = arguments.length, l, r;
    e: for (; e; ) {
      if (e.args.length !== arguments.length) {
        e = e.next;
        continue;
      }
      for (r = 0; r < i; r++)
        if (e.args[r] !== arguments[r]) {
          e = e.next;
          continue e;
        }
      return e !== n && (e === t && (t = e.prev), e.prev.next = e.next, e.next && (e.next.prev = e.prev), e.next = n, e.prev = null, n.prev = e, n = e), e.val;
    }
    for (l = new Array(i), r = 0; r < i; r++)
      l[r] = arguments[r];
    return e = {
      args: l,
      // Generate the result from original function
      val: f.apply(null, l)
    }, n ? (n.prev = e, e.next = n) : t = e, u === /** @type {MemizeOptions} */
    a.maxSize ? (t = /** @type {MemizeCacheNode} */
    t.prev, t.next = null) : u++, n = e, e.val;
  }
  return v.clear = function() {
    n = null, t = null, u = 0;
  }, v;
}
export {
  g as default
};
//# sourceMappingURL=index.js.map
